import React from 'react';
import './App.css';
import RituCSTLandingPage from './ritu-cst-landing-page';

function App() {
  return (
    <div className="App">
      <RituCSTLandingPage />
    </div>
  );
}

export default App;